import { AnnualKeyData as Data } from "app/shares/AnnualKeyData/annualKeyDataModel";
import { formatDecimal, formatMoney, formatPercent } from "app/formatting/functions";

export const getHeadline = (assetName: string) => `Kennzahlen zur ${assetName} Aktie`;
export const prepareKeyData = (data: Data[], currency: string) =>
    data.map(({ label, dividend, dividendPercentage, kgv, kbv }) => {
        const items = [
            dividendPercentage != null ? formatPercent(dividendPercentage) : "-",
            dividend != null ? formatMoney(dividend, currency) : "-",
            kgv != null ? formatDecimal(kgv) : "-",
            kbv != null ? formatDecimal(kbv) : "-"
        ];

        return {
            label,
            items
        };
    });
